import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTarget20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTarget20"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Target20)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M16.504 1.151 16.12 0l-.858.858-2.35 2.35-.284.283.079.394.074.37a7.311 7.311 0 1 0-3.47 13.747A7.31 7.31 0 0 0 15.748 7.22l.368.074.394.079.284-.284 2.35-2.35L20 3.88l-1.152-.384-1.759-.586zm-2.248 2.833 1.208-1.207.322.963.118.356.356.118.964.322-1.208 1.208-1.466-.294zm.867 6.709a5.81 5.81 0 0 1-5.811 5.81 5.811 5.811 0 1 1 3.544-10.415l-.828.827a4.652 4.652 0 1 0 1.06 1.06l.83-.827a5.8 5.8 0 0 1 1.205 3.545M9.312 7.54c.598 0 1.158.167 1.635.457l-.859.859a1.994 1.994 0 1 0 1.06 1.06l.86-.859A3.153 3.153 0 1 1 9.312 7.54m0 3.646a.494.494 0 1 0 0-.988.494.494 0 0 0 0 .988"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Target20">
                        <path fill="#fff" d="M0 0h20v20H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconTarget20);
